import React from "react";

export const YellowClock = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C3.58065 0 -4.97833e-10 3.58065 -1.11228e-09 8C-1.72672e-09 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 1.15439e-10 8 0ZM9.84194 11.2935L6.99677 9.22581C6.89677 9.15161 6.83871 9.03548 6.83871 8.9129L6.83871 3.48387C6.83871 3.27097 7.0129 3.09677 7.22581 3.09677L8.77419 3.09677C8.9871 3.09677 9.16129 3.27097 9.16129 3.48387L9.16129 7.92581L11.2097 9.41613C11.3839 9.54193 11.4194 9.78387 11.2935 9.95807L10.3839 11.2097C10.2581 11.3806 10.0161 11.4194 9.84194 11.2935Z"
        fill="#F4D51F"
      />
    </svg>
  );
};
